/* unplugin-vue-components disabled */import script from "./resourceCarousel.vue?vue&type=script&lang=js"
export * from "./resourceCarousel.vue?vue&type=script&lang=js"

import "./resourceCarousel.vue?vue&type=style&index=0&id=3bfd5ce6&lang=scss"

const __exports__ = script;

export default __exports__